export default "__VITE_ASSET__Dh12GSG$__"